"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Table = /** @class */ (function () {
    function Table(tableTop, tableHeight, headerHeight, footerHeight, pageHeaderHeight, ngZone, cd) {
        this.tableTop = tableTop;
        this.tableHeight = tableHeight;
        this.headerHeight = headerHeight;
        this.footerHeight = footerHeight;
        this.pageHeaderHeight = pageHeaderHeight;
        this.ngZone = ngZone;
        this.cd = cd;
        this.headerFixed = false;
        this.footerFixed = false;
        this.footerTransition = 0;
        this.headerTransition = 0;
        this.tableBottom = tableHeight + tableTop;
        this.bottomToHeadDistance = tableHeight - footerHeight;
    }
    Object.defineProperty(Table.prototype, "relativeTableTop", {
        get: function () {
            return this.tableTop - this.pageHeaderHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "correctedTableBottom", {
        get: function () {
            return this.tableBottom - this.pageHeaderHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "effectiveTableHeadHeight", {
        get: function () {
            return this.headerHeight + this.headerTransition;
        },
        enumerable: true,
        configurable: true
    });
    Table.prototype.scroll = function (scrollBy, scrollTop) {
        this.moveHeaderIfNecessary(scrollBy, scrollTop);
        this.fixOrUnfixHeader(scrollTop, scrollBy);
        this.fixOrUnfixFooter(scrollTop);
    };
    Table.prototype.moveHeaderIfNecessary = function (scrollBy, scrollTop) {
        if (this.headerFixed) {
            if (this.headerTransition <= 0 &&
                scrollBy > 0 &&
                !this.isTableInScrollContext(scrollTop)) {
                var correctedTransition = this.correctHeaderNegativeTransition(this.headerTransition - scrollBy);
                this.setNewValue('headerTransition', correctedTransition);
            }
            else if ((this.headerTransition < this.pageHeaderHeight &&
                this.headerTransition > 0) ||
                (this.headerTransition === this.pageHeaderHeight &&
                    scrollBy > 0) ||
                (this.headerTransition === 0 && scrollBy < 0)) {
                var correctedTransition = this.correctHeaderPositiveTransition(this.headerTransition - scrollBy);
                this.setNewValue('headerTransition', correctedTransition);
            }
            else if (scrollBy < 0) {
                this.setNewValue('headerTransition', Math.min(this.headerTransition - scrollBy, this.pageHeaderHeight));
            }
        }
    };
    Table.prototype.correctHeaderPositiveTransition = function (transition) {
        transition = Math.min(transition, this.pageHeaderHeight);
        transition = Math.max(transition, 0);
        return transition;
    };
    Table.prototype.correctHeaderNegativeTransition = function (transition) {
        transition = Math.max(transition, -this.headerHeight);
        transition = Math.min(transition, 0);
        return transition;
    };
    Table.prototype.currentFooterTop = function (scrollTop) {
        return this.currentFooterBottom(scrollTop) - this.footerHeight;
    };
    Table.prototype.currentFooterBottom = function (scrollTop) {
        return this.tableBottom - scrollTop;
    };
    Table.prototype.fixOrUnfixHeader = function (scrollTop, scrollBy) {
        if (!this.headerFixed &&
            scrollTop > this.relativeTableTop &&
            this.isTableInScrollContext(scrollTop)) {
            this.setNewValue('headerFixed', true);
            this.setNewValue('headerTransition', this.calculateNecessaryTransitionForFixing(scrollTop));
        }
        else if (scrollTop <= this.relativeTableTop && this.headerFixed) {
            this.setNewValue('headerFixed', false);
            this.setNewValue('headerTransition', 0);
        }
        else if (this.headerFixed &&
            !this.isTableInScrollContext(scrollTop)) {
            this.setNewValue('headerFixed', false);
            this.setNewValue('headerTransition', 0);
        }
    };
    Table.prototype.isTableInScrollContext = function (scrollTop) {
        return (scrollTop <=
            this.bottomToHeadDistance +
                this.relativeTableTop -
                this.effectiveTableHeadHeight);
    };
    Table.prototype.calculateNecessaryTransitionForFixing = function (scrollTop) {
        var transition = this.correctHeaderPositiveTransition(scrollTop -
            (this.bottomToHeadDistance +
                this.relativeTableTop -
                this.headerHeight));
        transition = transition < 0 ? 0 : transition;
        return transition;
    };
    Table.prototype.fixOrUnfixFooter = function (scrollTop) {
        if (window.innerHeight < this.currentFooterBottom(scrollTop) &&
            !this.footerFixed) {
            this.setNewValue('footerFixed', true);
        }
        else if (window.innerHeight >= this.currentFooterBottom(scrollTop) &&
            this.footerFixed) {
            this.setNewValue('footerFixed', false);
        }
    };
    Table.prototype.setNewValue = function (fieldName, newValue) {
        var _this = this;
        this[fieldName] = this.ngZone.run(function () {
            var oldValue = _this[fieldName];
            var changed = oldValue !== newValue;
            _this[fieldName] = newValue;
            if (changed) {
                _this.cd.detectChanges();
            }
            return newValue;
        });
    };
    return Table;
}());
exports.Table = Table;
//# sourceMappingURL=table.js.map